import { Routes } from "@angular/router";

export const mainLayoutRoutes: Routes = [
  {
    path: "platform-admin",
    loadChildren: () =>
      import("../../resources/client/platform-admin/platform-admin.module").then(
        (m) => m.PlatformAdminModule
      ),
  },
  {
    path: "deals",
    loadChildren: () =>
      import("../../resources/libraries/deals/deals.module").then(
        (m) => m.DealsModule
      ),
  },
  {
    path: "account-manager",
    loadChildren: () =>
      import("../../resources/client/account-manager/account-manager.module").then(
        (m) => m.AccountManagerModule
      ),
  },
  {
    path: "account-statement",
    loadChildren: () =>
      import("../../resources/account-statement/account-statement.module").then(
        (m) => m.AccountStatementModule
      ),
  },
  {
    path: "platform-disabled",
    loadChildren: () =>
      import("../../shared/components/disabled-platform/disable-platform.module").then(
        (m) => m.DisabledPlatformModule
      ),
  },
  {
    path: "user",
    loadChildren: () =>
      import("../../resources/client/users/user.module").then((m) => m.UserModule),
  },
  {
    path: "insertion-order",
    loadChildren: () =>
      import("../../resources/insertion-order/insertion-order.module").then(
        (m) => m.InsertionOrderModule
      ),
  },

  {
    path: "conversion-pixel",
    loadChildren: () =>
      import("../../resources/libraries/conversion-pixel/conversion-pixel.module"
      ).then((m) => m.ConversionPixelModule),
  },

  {
    path: "campaign",
    loadChildren: () =>
      import("../../resources/campaign/campaign.module").then(
        (m) => m.CampaignModule
      ),
  },
  {
    path: "creatives",
    loadChildren: () =>
      import("../../resources/libraries/creatives/creatives.module").then(
        (m) => m.CreativesModule
      ),
  },
  {
    path: "agency",
    loadChildren: () =>
      import("../../resources/client/agency/agency.module").then(
        (m) => m.AgencyModule
      ),
  },

  {
    path: "agency-advertiser",
    loadChildren: () =>
      import("src/app/resources/client/agency-advertiser/agency-advertiser.module").then(
        (m) => m.AgencyAdvertiserModule
      ),
  },

  {
    path: "adsp/agency-advertiser",
    loadChildren: () =>
      import("src/app/resources/client/adsp-agency-advertiser/adsp-agency-advertiser.module").then(
        (m) => m.AdspAgencyAdvertiserModule
      ),
  },

  {
    path: "advertiser",
    loadChildren: () =>
      import("../../resources/client/advertiser/advertiser.module").then(
        (m) => m.AdvertiserModule
      ),
  },

  {
    path: "segment-pixel",
    loadChildren: () =>
      import("../../resources/libraries/segment-pixel/segment-pixel.module").then(
        (m) => m.SegmentPixelModule
      ),
  },

  {
    path: "inventory",
    loadChildren: () =>
      import("../../resources/libraries/inventory/inventory.module").then(
        (m) => m.InventoryModule
      ),
  },

  {
    path: "report",
    loadChildren: () =>
      import("../../resources/reports/reports.module").then((m) => m.ReportsModule),
  },
  {
    path: "profile",
    loadChildren: () =>
      import("../../resources/Auth/profile/profile.module").then(
        (m) => m.ProfileModule
      ),
  },
  {
    path: "custom-location",
    loadChildren: () =>
      import("../../resources/libraries/custom-locations/custom-locations.module").then(
        (m) => m.CustomLocationsModule
      ),
  },
  {
    path: "tdsp/coupon-code",
    loadChildren: () =>
      import("../../resources/libraries/coupon-code/coupon-code.module").then(
        (m) => m.CouponCodeModule
      ),
  },
  {
    path: "tdsp/store",
    loadChildren: () =>
      import("../../resources/libraries/store/store.module").then(
        (m) => m.StoreModule
      ),
  },
  {
    path: "analytics",
    loadChildren: () =>
      import("../../resources/analytics/analytics.module").then(
        (m) => m.AnalyticsModule
      ),
  },
  {
    path: "contract",
    loadChildren: () =>
      import("../../resources/client/contract/contract.module").then(
        (m) => m.ContractModule
      ),
  },
  {
    path: "site-engagement",
    loadChildren: () =>
      import("../../resources/cdp/site-engagement/site.module").then(
        (m) => m.CdpModule
      ),
  },
  {
    path: "ads-engagement",
    loadChildren: () =>
      import("../../resources/cdp/ads-engagement/ads.module").then(
        (m) => m.AdsModule
      ),
  },
  {
    path: "file-upload",
    loadChildren: () =>
      import("../../resources/cdp/file-upload/file.module").then(
        (m) => m.FileModule
      ),
  },
  {
    path: "adsp/insertion-order",
    loadChildren: () =>
      import("../../resources/adsp/adsp-insertion-order/adsp-insertion-order.module").then(
        (m) => m.AdspInsertionOrderModule
      ),
  },
  {
    path: "adsp/campaign",
    loadChildren: () =>
      import("../../resources/adsp/adsp-line-item/adsp-line-item.module").then(
        (m) => m.AdspLineItemModule
      ),
  },
  {
    path: "adsp/creative",
    loadChildren: () =>
      import("../../resources/adsp/adsp-libraries/adsp-creative/adsp-creative.module").then(
        (m) => m.AdspCreativeModule
      ),
  },
  {
    path: "adsp/report",
    loadChildren: () =>
      import("../../resources/adsp/adsp-report/adsp-report.module").then(
        (m) => m.AdspReportModule
      ),
  },
  {
    path: "adsp/segment-pixel",
    loadChildren: () =>
      import("../../resources/adsp/adsp-libraries/adsp-segment/adsp-segment.module").then(
        (m) => m.AdspSegmentModule
      ),
  },
  {
    path: "adsp/event",
    loadChildren: () =>
      import("../../resources/adsp/adsp-libraries/adsp-event-management/adsp-events/adsp-events.module").then(
        (m) => m.AdspEventsModule
      ),
  },
  {
    path: "adsp/conversion-tracker",
    loadChildren: () =>
      import("../../resources/adsp/adsp-libraries/adsp-event-management/adsp-conversion-trackers/adsp-conversion-trackers.module").then(
        (m) => m.AdspConversionTrackersModule
      ),
  },
  {
    path: "adsp/deals",
    loadChildren: () =>
      import("../../resources/adsp/adsp-libraries/adsp-deal/adsp-deal.module").then(
        (m) => m.AdspDealModule
      ),
  },
  {
    path: "adsp/inventory",
    loadChildren: () =>
      import("../../resources/adsp/adsp-libraries/adsp-inventory-list/adsp-inventory-list.module").then(
        (m) => m.AdspInventoryListModule
      ),
  },
  {
    path: "bdsp/insertion-order",
    loadChildren: () =>
      import("../../resources/bdsp/bdsp-insertion-order/bdsp-insertion-order.module").then(
        (m) => m.BdspInsertionOrderModule
      ),
  },
  {
    path: "bdsp/segment-pixel",
    loadChildren: () =>
      import("../../resources/bdsp/bdsp-libraries/bdsp-segment/bdsp-segment.module").then(
        (m) => m.BdspSegmentModule
      ),
  },
  {
    path: "bdsp/custom-list",
    loadChildren: () =>
      import("../../resources/bdsp/bdsp-libraries/bdsp-custom-list/bdsp-custom-list.module").then(
        (m) => m.BdspCustomListModule)
  },
  {
    path: "bdsp/campaign",
    loadChildren: () =>
      import("../../resources/bdsp/bdsp-line-item/bdsp-line-item.module").then(
        (m) => m.BdspLineItemModule
      ),
  },
  {
    path: "bdsp/agency-advertiser",
    loadChildren: () =>
      import("src/app/resources/client/bdsp-agency-advertiser/bdsp-agency-advertiser.module").then(
        (m) => m.BdspAgencyAdvertiserModule
      ),
  },
  {
    path: "bdsp/event",
    loadChildren: () =>
      import("../../resources/bdsp/bdsp-libraries/bdsp-events/bdsp-events.module").then(
        (m) => m.BdspEventsModule),
  },
  {
    path: "bdsp/delivery-modifier",
    loadChildren: () =>
      import("../../resources/bdsp/bdsp-libraries/bdsp-delivery-modifiers/bdsp-delivery-modifiers.module").then(
        (m) => m.BdspDeliveryModifierModule),
  },
  {
    path: "bdsp/creative",
    loadChildren: () =>
      import("src/app/resources/bdsp/bdsp-libraries/bdsp-creative/bdsp-creative.module").then(
        (m) => m.BdspCreativeModule
      ),
  },
  {
    path: "bdsp/report",
    loadChildren: () =>
      import("src/app/resources/bdsp/bdsp-reports/bdsp-reports.module").then(
        (m) => m.BdspReportsModule
      ),
  },
  {
    path: "bdsp/deals",
    loadChildren: () =>
      import("src/app/resources/bdsp/bdsp-libraries/bdsp-deals/bdsp-deal.module").then(
        (m) => m.BdspDealModule
      ),
  },
  {
    path: "tdsp/segments",
    loadChildren: () =>
      import("src/app/resources/tdsp/tdsp-libraries/tdsp-segment/tdsp-segment.module").then(
        (m) => m.TdspSegmentModule
      ),
  },
  {
    path: "platform-notification",
    loadChildren: () =>
      import("src/app/resources/platform-notifications/platform-notification.module").then(
        (m) => m.PlatformNotificationsModule
      ),
  },
  {
    path: "bdsp/native-offer",
    loadChildren: () =>
      import("src/app/resources/bdsp/bdsp-libraries/bdsp-native-offers/bdsp-native-offers.module").then(
        (m) => m.BdspNativeOffersModule
      ),
  },
  {
    path: "tdsp/agency-advertiser",
    loadChildren: () =>
      import("src/app/resources/client/tdsp-agency-advertiser/tdsp-agency-advertiser.module").then(
        (m) => m.TdspAgencyAdvertiserModule
      ),
  },
  {
    path: "tdsp/audience-builder",
    loadChildren: () =>
      import("../../resources/tdsp/tdsp-libraries/tdsp-audience-builder/tdsp-audience-builder.module").then(
        (m) => m.TdspAudienceBuilderModule
      ),
  },
  {
    path: "tdsp/seed",
    loadChildren: () =>
      import("../../resources/tdsp/tdsp-libraries/tdsp-seeds/tdsp-seeds.module").then(
        (m) => m.TdspSeedsModule
      ),
  },
  {
    path: "tdsp/campaign",
    loadChildren: () =>
      import("../../resources/tdsp/tdsp-line-item/tdsp-line-item.module").then(
        (m) => m.TdspLineItemModule
      ),
  },
  {
    path: "tdsp/creative",
    loadChildren: () =>
      import(
        "src/app/resources/tdsp/tdsp-libraries/tdsp-creatives/tdsp-creative.module"
      ).then((m) => m.TdspCreativeModule),
  },
  {
    path: "tdsp/report",
    loadChildren: () =>
      import("src/app/resources/tdsp/tdsp-reports/tdsp-reports.module").then(
        (m) => m.TdspReportsModule)
  }, {
    path: "tdsp/insertion-order",
    loadChildren: () =>
      import("../../resources/tdsp/tdsp-insertion-order/tdsp-insertion-order.module").then(
        (m) => m.TdspInsertionOrderModule
      ),
  },
  {
    path: "tdsp/inventory-list",
    loadChildren: () =>
      import("../../resources/tdsp/tdsp-libraries/tdsp-inventory/tdsp-inventory.module").then(
        (m) => m.TdspInventoryModule
      ),
  },
  {
    path: "tdsp/content-category",
    loadChildren: () =>
      import("../../resources/tdsp/tdsp-libraries/tdsp-inventory-category/tdsp-inventory.module").then(
        (m) => m.TdspInventoryCategoryModule
      ),
  },
  {
    path: "tdsp/custom-location",
    loadChildren: () =>
      import(
        "src/app/resources/tdsp/tdsp-libraries/tdsp-custom-location/tdsp-custom-location.module"
      ).then((m) => m.TdspCustomLocationModule),
  },
  {
    path: "tdsp/contextual-keywords",
    loadChildren: () =>
      import(
        "src/app/resources/tdsp/tdsp-libraries/tdsp-contextual-category/tdsp-contextual-category.module"
      ).then((m) => m.TdspContextualCategoryModule),
  },
  {
    path: "tdsp/conversion-pixel",
    loadChildren: () =>
      import(
        "src/app/resources/tdsp/tdsp-libraries/tdsp-conversion-pixel/tdsp-conversion-pixel.module"
      ).then((m) => m.TdspConversionPixelModule)
  },
  {
    path: "tdsp/deals",
    loadChildren: () =>
      import(
        "src/app/resources/tdsp/tdsp-libraries/tdsp-deals/tdsp-deal.module"
      ).then((m) => m.TdspDealModule),
  },
  {
    path: "tdsp/dashboard",
    loadChildren: () =>
      import(
        "src/app/resources/tdsp/tdsp-dashboard/tdsp-dashboard.module"
      ).then((m) => m.TdspDashboardModule),
  },
  {
    path: "dco/segments",
    loadChildren: () =>
      import(
        "src/app/resources/dco/dco-segments/dco-segments.module"
      ).then((m) => m.DcoSegmentsModule),
  },
  {
    path: "dco/product-feed",
    loadChildren: () =>
      import(
        "src/app/resources/dco/dco-product-feed/dco-product-feed.module"
      ).then((m) => m.DcoProductFeedModule),
  },
  {
    path: "dco/rules",
    loadChildren: () =>
      import(
        "src/app/resources/dco/dco-rules/dco-rules.module"
      ).then((m) => m.ProductRulesModule),
  },
  // {
  //   path: "dco/creatives",
  //   loadChildren: () =>
  //     import(
  //       "src/app/resources/dco/dco-library/dco-creatives/dco-creatives.module"
  //     ).then((m) => m.DcoCreativesModule),
  // },
  {
    path: "dco/creative-packaging",
    loadChildren: () =>
      import(
        "src/app/resources/dco/dco-creative-packaging/dco-creative-package.module"
      ).then((m) => m.DcoCreativePackageModule),
  },
  {
    path: "tdsp/media-plan",
    loadChildren: () =>
      import("../../resources/tdsp/tdsp-media-plan/tdsp-media-plan.module").then(
        (m) => m.TdspMediaPlanModule
      ),
  },
  {
    path: "tdsp-hyperlocal/insertion-order",
    loadChildren: () =>
      import("../../resources/tdsp/tdsp-insertion-order/tdsp-insertion-order.module").then(
        (m) => m.TdspInsertionOrderModule
      ),
  },
  {
    path: "tdsp-hyperlocal/campaign",
    loadChildren: () =>
      import("../../resources/tdsp/tdsp-line-item/tdsp-line-item.module").then(
        (m) => m.TdspLineItemModule
      ),
  },
  {
    path: "tdsp-hyperlocal/agency-advertiser",
    loadChildren: () =>
      import("src/app/resources/client/tdsp-agency-advertiser/tdsp-agency-advertiser.module").then(
        (m) => m.TdspAgencyAdvertiserModule
      ),
  },
  {
    path: "tdsp-hyperlocal/report",
    loadChildren: () =>
      import("src/app/resources/tdsp/tdsp-reports/tdsp-reports.module").then(
        (m) => m.TdspReportsModule
      ),
  },
  // {
  //   path: "tdsp-hyperlocal/media-plan",
  //   loadChildren: () =>
  //     import("../../resources/tdsp/tdsp-media-plan/tdsp-media-plan.module").then(
  //       (m) => m.TdspMediaPlanModule
  //     ),
  // },
  {
    path: "tdsp-hyperlocal/creative",
    loadChildren: () =>
      import("src/app/resources/tdsp/tdsp-libraries/tdsp-creatives/tdsp-creative.module").then(
        (m) => m.TdspCreativeModule
      ),
  },
  {
    path: "tdsp-hyperlocal/conversion-pixel",
    loadChildren: () =>
      import("src/app/resources/tdsp/tdsp-libraries/tdsp-conversion-pixel/tdsp-conversion-pixel.module").then(
        (m) => m.TdspConversionPixelModule
      ),
  },
  {
    path: "tdsp-hyperlocal/custom-location",
    loadChildren: () =>
      import("src/app/resources/tdsp/tdsp-libraries/tdsp-custom-location/tdsp-custom-location.module").then(
        (m) => m.TdspCustomLocationModule
      ),
  },
  {
    path: "tdsp-hyperlocal/deals",
    loadChildren: () =>
      import("src/app/resources/tdsp/tdsp-libraries/tdsp-deals/tdsp-deal.module").then(
        (m) => m.TdspDealModule
      ),
  },
  {
    path: "tdsp-hyperlocal/inventory-list",
    loadChildren: () =>
      import("../../resources/tdsp/tdsp-libraries/tdsp-inventory/tdsp-inventory.module").then(
        (m) => m.TdspInventoryModule
      ),
  },
  {
    path: "tdsp-hyperlocal/content-category",
    loadChildren: () =>
      import("../../resources/tdsp/tdsp-libraries/tdsp-inventory-category/tdsp-inventory.module").then(
        (m) => m.TdspInventoryCategoryModule
      ),
  },
  {
    path: "tdsp-hyperlocal/contextual-keywords",
    loadChildren: () =>
      import("src/app/resources/tdsp/tdsp-libraries/tdsp-contextual-category/tdsp-contextual-category.module").then(
        (m) => m.TdspContextualCategoryModule
      ),
  },
  {
    path: "tdsp-hyperlocal/segments",
    loadChildren: () =>
      import("src/app/resources/tdsp/tdsp-libraries/tdsp-segment/tdsp-segment.module").then(
        (m) => m.TdspSegmentModule
      ),
  },
  {
    path: "tdsp-hyperlocal/seed",
    loadChildren: () =>
      import("../../resources/tdsp/tdsp-libraries/tdsp-seeds/tdsp-seeds.module").then(
        (m) => m.TdspSeedsModule
      ),
  },
  {
    path: "tdsp-hyperlocal/audience-builder",
    loadChildren: () =>
      import("../../resources/tdsp/tdsp-libraries/tdsp-audience-builder/tdsp-audience-builder.module").then(
        (m) => m.TdspAudienceBuilderModule
      ),
  },
  {
    path: 'dco/library',
    loadChildren: () =>
      import(
        'src/app/resources/dco/dco-library/dco-library.module'
      ).then((m) => m.DcolibraryModule),
  },
  { path: "**", redirectTo: "error", pathMatch: "full" },
];
